export default __webpack_public_path__ + "static/media/mixed.6a0376a6.png";